import request from '@/axios'

export function fetchCallLogApi (query, lead_id, customerId) {
  return request({
    url:`/call_logs/list/${customerId}/${lead_id}?page=${query}`,
    method:'GET'
  })
}

export function AddCallLogApi (payload, customerId, lead_id) {
  return request({
    url:`/call_logs/create/${customerId}/${lead_id}`,
    method:'POST',
    data: payload
  })
}

export function FetchSingleCallId (id) {
  return request({
    url:`/call_logs/show/${id}`,
    method:'GET'
  })
}

export function UpdateCallLog (payload, id) {
  return request({
    url:`/call_logs/edit/${id}`,
    method:'POST',
    data: payload
  
  })
}
export function DeleteCallLog (id) {
  return request({
    url:`/call_logs/delete/${id}`,
    method:'GET'
  
  })
}